import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import mixin_fields from './fields'
import {createParams} from './utils'
import {saveContractTypeApi} from './service'
import {mapGetters} from "vuex";

export default {
    mixins:[mixin_fields],
    data() {
        return {
            show: false,
            saving: false,
            params:  createParams()
        }
    },
    computed: {
        ...mapGetters({
            teams_hash: 'async/root_teams_hash',
        }),
    },
    mounted() {
        //  setTimeout(() => {
        //     this.show = true
        //  }, 100);
    },
    methods: {
        edit(data) {
            if (data) {
                const params = JSON.parse(JSON.stringify(data))
                params.teams = params.teams.map(item => item.id)
                this.params = params
            } else {
                this.params = createParams()
            }
            this.show = true
        },
        submit() {
            if (!this.$refs.base.validate()) {
                // this.$Message.error('表单有误，请注意检查！')
                return 
            }
            const params = JSON.parse(JSON.stringify(this.params))
            this.saving = true
            params.teams = params.teams.map((i) => {
                const team = this.teams_hash[i]
                return {
                    id: i,
                    name: team && team.name
                }
            
            })
            saveContractTypeApi(params).then(() => {
                this.$Message.success(this.params.id ? '编辑成功！' : '新增成功！')
                this.show = false
                this.$emit('success', !!params.id)
            }).finally(() => {
                this.saving = false
            })
        }
    },
    render() {
        const _this = this
        return <VModal
            dynamicHeight
            heightRate={0.9}
            v-model={_this.show}
            title={this.params.id ? '编辑合同类型' : '新增合同类型'}
            loading={_this.saving}
            width={600}
            ref="modal"
            on={{
                ok: () => {
                    this.submit() 
                }
            }}
        >
            <VForm ref="base"
                v-model={_this.params}
                fields={_this.fields}/>
        </VModal>
    }
}